import {create} from 'zustand';
import {PREVIEW_DATA_DEFAULT} from './constants';
import {UseRequestPreviewDataStoreProps} from './types';

export const useRequestPreviewDataStore = create<UseRequestPreviewDataStoreProps>(set => ({
	data: PREVIEW_DATA_DEFAULT,
	setData: data => set({data}),
	resetData: () => set({data: PREVIEW_DATA_DEFAULT}),
}));
